"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpUplot = void 0;
const _ = __importStar(require("lodash"));
const uplot_1 = __importDefault(require("uplot"));
const vue_property_decorator_1 = require("vue-property-decorator");
const helpers_1 = require("./helpers");
const { linear, spline, stepped, bars } = uplot_1.default.paths;
function createOptions(options) {
    _.each(options.series, ser => {
        const steppedOptions = _.get(ser, 'stepped');
        if (stepped && _.isObject(steppedOptions)) {
            ser.paths = stepped(steppedOptions);
        }
    });
    return options;
}
let ItpUplot = class ItpUplot extends vue_property_decorator_1.Vue {
    _chart;
    _options;
    id;
    options;
    chartData;
    onOptionsChanged(current, previous) {
        this._options = createOptions(current);
        const optionsState = (0, helpers_1.optionsUpdateState)(previous, current);
        if (!this._chart || optionsState === 'create') {
            this._destroy();
            this._create();
        }
        else if (optionsState === 'update') {
            this._chart.setSize({ width: current.width, height: current.height });
        }
    }
    onChartDataChanged(current, previous) {
        if (!this._chart) {
            this._create();
        }
        else if (!(0, helpers_1.chartDataMatches)(previous, current)) {
            this._chart.setData(current);
        }
    }
    data() {
        return { _chart: null };
    }
    mounted() {
        this._create();
    }
    beforeDestroy() {
        this._destroy();
    }
    onMouseEnter($event) {
        if (this._chart) {
            this._chart.syncRect();
        }
    }
    _create() {
        if (this._options == null) {
            this._options = createOptions(this.options);
        }
        this._chart = new uplot_1.default(this._options, this.chartData, this.$el);
    }
    _destroy() {
        if (this._chart) {
            this._chart.destroy();
            this._chart = undefined;
        }
    }
};
exports.ItpUplot = ItpUplot;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpUplot.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpUplot.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpUplot.prototype, "chartData", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ItpUplot.prototype, "onOptionsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('chartData'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ItpUplot.prototype, "onChartDataChanged", null);
exports.ItpUplot = ItpUplot = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div @mouseenter="onMouseEnter($event)"></div>' })
], ItpUplot);
//# sourceMappingURL=uplot.js.map